// Module
var code = "<div class=\"\"> <div class=\"collection-popUp table-type-buttons-group\"> <!--ko foreach: EntityTypes--> <button data-bind=\"click: $parent.SelectTypedScreen.bind($parent), text: $data.GetName(), css: $parent.GetTypeButtonColor($data)\" class=\"btn table-type-btn\"></button> <!-- /ko--> </div> </div>";
// Exports
export default code;